/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
		// Application Title
		'appTitle': 'פרויקט Gemini',
		'appExit': 'מעבר לדף הפתיחה',


		'widgetsListLabel': 'רשימת פקדים. בחרו פקד ולחצו על Enter כדי להוסיף.',

		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		//General
		listSeparator: ', ',
		pointSeparator: ':',

		'insync': 'עדכני',
		'dirty': 'לא עדכני',
		'conflict': 'סתירות בשמירת התצוגה',
		'error': 'בעיות בשמירת התצוגה',
		'failure': 'לא ניתן לתקשר עם השרת',
		'saveFailed': 'לא ניתן לשמור את התצוגה',

		'wa_insync': 'נשמר',
		'wa_conflict': 'סתירות בשמירת התצוגה',
		'wa_error': 'לא ניתן לשמור את התצוגה',
		'wa_failure': 'לא ניתן לתקשר עם השרת',

		// Menu Labels
		'changeDisplay': 'שינוי תצוגה',
		'changeToColumnChart': 'מעבר לתרשים עמודות',
		'changeToBubbleChart': 'שינוי תרשים בועות',
		'toggleMoveHandles': 'מיתוג ידיות העברה',
		'undo': 'ביטול פעולה',
		'redo': 'שחזור פעולה',
		'mode': 'שינוי המצב',

		'untitled': 'ללא כותרת',
		'remove': 'סילוק',
		'editTitle': 'עריכת הכותרת',
		'edit': 'עריכה',
		'done': 'סיום',

		// Data tray
		'dataTrayHandleOpenLabel': 'פתיחת מגש הנתונים',
		'dataTrayHandleCloseLabel': 'סגירת מגש הנתונים',
		'dataTrayHandleOpenLabelSceneSelector': 'פתיחת בורר הזירות',
		'dataTrayHandleCloseLabelSceneSelector': 'סגירת בורר הזירות',

		// Dialogs
		'dlg_loading': 'טעינה מתבצעת...‏',
		'dlg_ok': 'אישור',
		'dlg_cancel': 'ביטול',
		'dlg_close': 'סגירה',
		'dlg_update': 'עדכון',
		'dlg_renameBoardTitle': 'שינוי שם אובייקט זה',
		'dlg_renameDatasetTitle': 'שינוי שם ערכת נתונים זו',
		'dlg_renameSceneTitle': 'שינוי שם זירה זו',
		'dlg_NameLabel': 'שם:',
		'dlg_NewNameLabel': 'שם חדש:',
		'dlg_DefaultNameWithDataSet': 'תצוגה %{name}',
		'dlg_ShareTitle': 'שיתוף תוכן',
		'dlg_UnshareTitle': 'סילוק שיתוף תוכן',
		'dlg_ShareUser': 'זיהוי משתמש:',
		'dlg_NewColumnLabel': 'שם חישוב חדש:',

		'dlg_new': 'חדש...‏',
		'dlg_open': 'פתיחה...‏',
		'dlg_makeACopy': 'יצירת עותק',
		'dlg_rename': 'שינוי שם...‏',
		'dlg_moreToCome': 'עוד פעולות בקרוב...‏',
		'dlg_createStory': 'יצירת סיפור',

		'dlg_use': 'שימוש',
		'dlg_IntentResultsTitle': 'בחירת ערכת נתונים',
		'dlg_IntentHeaderName': 'שם',
		'dlg_IntentHeaderDate': 'תאריך',
		'dlg_IntentSearchClear': 'ניקוי מושגים לחיפוש כוונה',
		'dlg_IntentNoMatch': 'לא ניתן למצוא התאמות. נסו שוב עם מונחי החיפוש שונים.',

		'dlg_RelinkDatasetTitle': 'החלפת ערכת הנתונים \'%{datasetName}\' עם...‏',

		open_error: 'אירעה בעיה בפתיחת התצוגה.',

		// Delete Board
		'del_dialogTitle': 'אישור מחיקה',
		'del_itemMsg': 'אתם בטוחים שברצונכם למחוק את \'%{name}\'?‏',
		'del_itemsMsg': 'אתם בטוחים שברצונכם למחוק \'%{count}\' פריטים ?‏',
		'del_deleteErr': 'לא ניתן למחוק את \'%{name}\'',

		// List Sorting
		'dlg_ascending': 'עולה',
		'dlg_descending': 'יורד',
		'dlg_custom': 'מותאם',
		'dlg_none': 'ללא',

		// Input Placeholders
		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		'search': 'חיפוש',

		'searchHint': 'חיפוש בכל הנתונים',
		'clearSearchResult': 'ניקוי תוצאות חיפוש',
		// Shapes and shapes categories
		// Basic shapes
		'shapesBasicShapesCat': 'בסיסי',
		'shapesCircle': 'מעגל',
		'shapesHexagon': 'משושה',
		'shapesLine': 'קו',
		'shapesOctagon': 'מתומן',
		'shapesPentagon': 'מחומש',
		'shapesSquare': 'ריבוע',
		'shapesTriangle': 'משולש',
		'shapesDiamond': 'מעוין',
		'shapesTitle': 'תכונות צורה',


		// Advanced shapes
		'shapesAdvancedShapesCat': 'מתקדם',
		'shapesSquareRounded': 'ריבוע מעוגל',
		'shapesStar': 'כוכב',
		'shapesChevron': 'שברון',
		'shapesBadge_ribbon': 'סרט סמל',
		'shapesBadge': 'סמל',
		'shapesHeart': 'לב',
		'shapesExclamation': 'סימן קריאה',
		'shapesTrendingup': 'מגמה עולה',
		'shapesTrendingdown': 'מגמה יורדת',
		'shapesX': 'X',

		// People shapes
		'shapesPeopleCat': 'אנשים',
		'shapesFemale': 'נקבה',
		'shapesHappyface': 'פנים שמחים',
		'shapesMale': 'זכר',
		'shapesMan': 'גבר',
		'shapesNeutralface': 'פנים נייטרליים',
		'shapesSadface': 'פנים עצובים',
		'shapesShakehands': 'לחיצת ידיים',
		'shapesThumbsdown': 'שלילי',
		'shapesThumbsup': 'חיובי',
		'shapesWoman': 'אישה',

		// Weather and places
		'shapesPlacesWeatherCat': 'מקומות ומזג אוויר',
		'shapesCity': 'עיר',
		'shapesCloud': 'ענן',
		'shapesEducation': 'חינוך',
		'shapesGovernment': 'ממשלה',
		'shapesHalfcloud': 'חצי ענן',
		'shapesHouse': 'בית',
		'shapesMoon': 'ירח',
		'shapesRain': 'גשם',
		'shapesSunny': 'שמשי',

		//Vehicles
		'shapesVehiclesCat': 'כלי רכב',
		'shapesAirplane': 'מטוס',
		'shapesCar': 'מכונית',
		'shapesShip': 'ספינה',
		'shapesShoppingcart': 'עגלת קניות',
		'shapesTrain': 'רכבת',
		'shapesTruck': 'משאית',

		//Objects
		'shapesObjectsCat': 'אובייקטים',
		'shapesBook': 'ספר',
		'shapesBriefcase': 'תיק מסמכים',
		'shapesCalendar': 'לוח שנה',
		'shapesCheck': 'סימן וי',
		'shapesClock': 'שעון',
		'shapesDesktop': 'שולחן עבודה',
		'shapesDocument': 'מסמך',

		'shapesFood': 'מזון',
		'shapesGear': 'גלגל שינויים',
		'shapesHealth': 'בריאות',

		'shapesIdea': 'רעיון',
		'shapesMobile': 'נייד',
		'shapesMoney_bill': 'שטר כסף',
		'shapesMoney_coin': 'מטבע כסף',
		'shapesPiggybank': 'קופת חסכון',
		'shapesStackofpaper': 'ערימת ניירות',
		'shapesStickynote1': 'פתקית 1',
		'shapesStickynote2': 'פתקית 2',
		'shapesTarget': 'מטרה',
		'shapesTool': 'כלי',

		'shapesUmbrella': 'מטריה',

		'shapesBrain': 'מוח',
		'shapesSkull': 'גולגולת',
		'shapesEye': 'עין',

		// Arrows shapes
		'shapesArrowsCat': 'חצים',
		'shapesRightArrow': 'חץ ימינה',
		'shapesLeftArrow': 'חץ שמאלה',
		'shapesDoubleArrow': 'חץ כפול',
		'shapesCurvedArrow': 'חץ מעוקל',

		// Callouts shapes
		'shapesCalloutsCat': 'בועות הסבר',
		'shapesRectCallout': 'בועת הסבר',

		// Images
		'imageWidgetTitle': 'פקד תמונה',
		'imageTextLabel': 'הדביקו את ה-URL ולחצו על Enter כדי לשמור אותו',
		'imgUrl': 'URL של תמונה',
		'imgPasteLink': 'הדביקו את ה-URL ולחצו על Enter כדי לשמור אותו',
		'imgResizeToFit': 'שינוי גודל כדי להתאמה לגודל התמונה',
		'imgHeight': 'גובה:',
		'imgWidth': 'רוחב:',
		'imgTransparency': 'שקיפות:',
		'imgMissingUrl': 'URL התמונה חסר',
		'imgUrlValidationError': 'URL התמונה אינו חוקי',

		// Data player widget
		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		'playButtonLabel': 'הרצה',
		'dataPlayerValueListLabel': 'ערכי נגן נתונים',
		// Text Widget
		'textStyle': 'סגנונות',
		'textStyleDescription': 'סגנונות תמליל מעוצבים מראש',
		'textTitleStyle': 'כותרת',
		'textTitleSmallStyle': 'כותרת קטן',
		'textSubtitleStyle': 'כותרת משנה',
		'textBodyStyle': 'גוף',
		'textBodySmallStyle': 'גוף קטן',
		'textCaptionStyle': 'כיתוב',
		'textQuoteStyle': 'ציטוט',
		'textQuoteSmallStyle': 'ציטוט קטן',
		'textResponsiveStyle': 'גודל אוטומטי',
		'textAutoFontSize': 'אוטומטי',
		'responsiveCoachmarkTitle': 'גודל גופן אוטומטי',
		'responsiveCoachmarkContents': 'גודל הגופן מותאם אוטומטית כשמשנים סוג תמליל זה. תוכלו להגדיר את גודל גופן בתכונות התמליל.',

		'propText': 'תכונות תמליל',
		'propTextReturn': 'תכונות תמליל',
		'textPlaceHolder': 'הקלידו את התמליל שלכם כאן.',

		'textFontSize': 'גודל גופן',
		'textFontFamily': 'משפחת גופנים',
		'textFontWeight': 'עובי גופן',

		// Widget Properties
		'propImageLink': 'קישור תמונה',
		'propMissingURL': 'ציון URL',
		'propImgTop': 'תכונות תמונה',
		'propGeneralReturn': 'תכונות כלליות',
		'propStyle': 'כללי',
		'propStyleReturn': 'כללי',
		'propFillColor': 'צבע מילוי',
		'propTextColor': 'צבע תמליל',
		'propBorderColor': 'צבע גבול',
		'propMaintainAxisScales': 'שמירת קנה מידה של ציר',
		'propShowItemLabel': 'הצגת תווית הפריט',
		'propHideLegend': 'הסתרת המקרא',
		'propColorPalette': 'בורר צבעים',
		'propLegendPosition': 'מיקום מקרא',
		'propHideAxisTitleLabels': 'הסתרת כותרות הצירים',
		'propLineColor': 'צבע קו',
		'propBubbleColor': 'צבע בועה',
		'propInterpolation': 'קווים חלקים',
		'propElementColor': 'צבע מרכיב המחשה חזותית',
		'propSymbolShape': 'צורת סמל',
		'propHeatScalePalette': 'סדר צבעים',
		'propHeatScalePalette_tooltipDarkerForLowerValue': 'צבעים כהים יותר מייצגים ערכים קטנים יותר.',
		'propHeatScalePalette_tooltipDarkerForHigherValue': 'צבעים כהים יותר מייצגים ערכים גדולים יותר.',
		'propImageDetails': 'פרטי תמונה',
		'propWebDetails': 'פרטי דף רשת',
		'propMediaDetails': 'פרטי מדיה',
		'propPasteLink': 'ציינו את ה-URL ולחצו על Enter',

		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		'propScaleLabel': 'כמות איקונים',
		'propScaleDescription': 'בחרו כמות האיקונים',
		'propScaleFew': 'נמוך',
		'propScaleDefault': 'ברירת מחדל',
		'propScaleMany': 'גבוה',

		'mediaAriaLabel': 'קלט URLt',
		'ariaGroupLabel': 'קטגוריית רשימה נפתחת: %{cateoryLabel} פריט: %{itemLabel}. לחצו על מקש החץ היורד כדי להרחיב. לחצו על מקש החץ העולה כדי לנווט או לחצו על מקש ESCAPE כדי לכווץ.',

		// Timer
		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		'lastRefresh': 'רענון אחרון: לפני %{timeInterval}',
		'widgetTimer': 'קוצב זמן של פקד',

		// Theme colors
		'transparent': 'ללא צבע',
		'white': 'לבן',
		'lightGrey': 'אפור בהיר',
		'grey': 'אפור',
		'darkGrey': 'אפור כהה',
		'black': 'שחור',
		'lightBlue': 'כחול בהיר',
		'blue': 'כחול',
		'darkBlue': 'כחול כהה',
		'yellow': 'צהוב',
		'orange': 'כתום',
		'lime': 'צהוב-ירקרק',
		'green': 'ירוק',
		'peach': 'אפרסק',
		'red': 'אדום',
		'violet': 'סגול בהיר',
		'aqua': 'כחול ים',
		'purple': 'סגול',
		'plum': 'סגול כהה',

		// Dashboard
		'propDashboardBackgroundColor': 'צבע רקע',

		//Story
		'propShowStoryOverviewFirstSlide': 'הצגת כל הזירות בהתחלה',
		'propShowStoryOverviewLastSlide': 'הצגת כל הזירות בסוף',

		// Vis widget
		'propVisTypeReturn': 'סוגי המחשה חזותית',
		'propVisDetails': 'פרטים',

		// Animation properties for widgets
		'propAniDetails': 'הנפשה',
		'propAniDetailsReturn': 'הנפשה',
		'propAniEntrance': 'כניסה',
		'propAniTypeEntranceSlideIn': 'כניסה בהחלקה',
		'propAniTypeEntranceFadeIn': 'כניסה בעמעום',
		'propAniTypeEntrancePivotIn': 'כניסה על ציר',
		'propAniTypeEntranceScaleIn': 'כניסה בשינוי גודל',
		'propAniTypeEntranceShrinkIn': 'כניסה בכיווץ',
		'propAniDirectionInLeft': 'משמאל',
		'propAniDirectionInRight': 'מימין',
		'propAniDirectionInTop': 'מלמעלה',
		'propAniDirectionInBottom': 'מלמטה',
		'propAniExit': 'יציאה',
		'propAniTypeExitSlideIn': 'יציאה בהחלקה',
		'propAniTypeExitFadeIn': 'יציאה בעמעום',
		'propAniTypeExitPivotOut': 'יציאה על ציר',
		'propAniTypeExitScaleIn': 'יציאה בשינוי גודל',
		'propAniTypeExitExpandOut': 'יציאה בהרחבה',
		'propAniDirectionOutLeft': 'שמאלה',
		'propAniDirectionOutRight': 'ימינה',
		'propAniDirectionOutTop': 'למעלה',
		'propAniDirectionOutBottom': 'למטה',

		// Alignment picker
		'propAlignPickTop': 'יישור לראש',
		'propAlignPickRight': 'יישור לימין',
		'propAlignPickBottom': 'יישור לתחתית',
		'propAlignPickLeft': 'יישור לשמאל',
		'propAlignPickCenter': 'יישור למרכז',
		'propAlignPicker': 'יישור',

		// Toolbar picker
		'propToolbarPickBold': 'מודגש',
		'propToolbarPickUnderline': 'קו תחתי',
		'propToolbarPickItalic': 'נטוי',
		'propToolbarPickJustifyLeft': 'יישור לשמאל',
		'propToolbarPickJustifyCenter': 'יישור למרכז',
		'propToolbarPickJustifyRight': 'יישור לימין',
		'propToolbarPickJustify': 'יישור דו-צדדי',

		// Symbol shapes
		'propCircle': 'מעגל',
		'propTriangle': 'משולש',
		'propSquare': 'ריבוע',
		'propRect': 'מלבן',
		'propStar': 'כוכב',
		'propCross': 'צלב',
		'propPlus': 'פלוס',
		'propPoly': 'מצולע',


		// True and false selection
		'propTrue': 'True',
		'propFalse': 'False',

		// Position selection
		'propLeft': 'שמאל',
		'propRight': 'ימין',
		'propTop': 'עליונים',
		'propBottom': 'תחתונים',

		// Interpolation options
		'propSmooth': 'חלק',
		'propStraight': 'ישר',

		// indentedListView
		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		'srILVTreeLabel': 'רשימה', // screen reader label for tree role

		// widget move
		'srWidgetMoveLeft': 'העברה שמאלה', // screen reader
		'srWidgetMoveUp': 'העברה למעלה', // screen reader
		'srWidgetMoveRight': 'העברה ימינה', // screen reader
		'srWidgetMoveDown': 'העברה למטה', // screen reader

		// widget resize
		'srWidgetResizeBigger': 'הגדלה פרופורציונלית', // screen reader
		'srWidgetResizeSmaller': 'הקטנה פרופורציונלית', // screen reader
		'srWidgetResizeBiggerV': 'הגדלה אנכית', // screen reader
		'srWidgetResizeSmallerV': 'הקטנה אנכית', // screen reader
		'srWidgetResizeBiggerH': 'הגדלה אופקית', // screen reader
		'srWidgetResizeSmallerH': 'הקטנה אופקית', // screen reader

		// widget rotate
		'srWidgetRotateCW': 'סיבוב בכיוון השעון', // screen reader
		'srWidgetRotateCCW': 'סיבוב נגד כיוון השעון', // screen reader

		// Recommended types
		'visChange': 'שינוי המחשה',

		// Visualization
		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		'visualizationLabel': 'המחשה',
		'chartLabel': 'תרשים %{chartName}',
		'dataWidgetDescription': '%{widgetLabel}:‏ %{columnNames}',
		'f12KeyDescription': 'לחצו על F12 כדי לנווט בתוך הפקד.',
		'f10KeyDescription': 'לחצו על F10 כדי להפעיל את תצוגת המוקד של הפקד',

		'WidgetLabelWithDescripion': '%{label}. %{description}',

		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		'summaryLabel': '%{label} עם הערך %{value}',

		'shapeColorLabel': 'צבע צורה',
		'showLegendLabel': 'הצגת מקרא',

		//Webpage
		'webpageWidgetTitle': 'פקד דף רשת',
		'webpagePasteLink': 'הדביקו את ה-URL ולחצו על Enter כדי לשמור אותו',
		'propWebpageLink': 'URL של דף רשת',
		'propWebpageTitle': 'כותרת דף רשת',
		'propWebpageTitleDescription': 'הכותרת של דף הרשת',
		'propWebpageTop': 'תכונות דף רשת',
		'webpageMissingUrl': 'ה-URL של דף הרשת חסר',
		'webpageUrlValidationError': 'ה-URL של דף הרשת אינו חוקי',
		'webpageHttpValidationError': 'יש לגשת אל דף הרשת באמצעות קישור HTTPS להצגה בדפדפן',

		//VizState
		'vzErrorLoading': 'לא ניתן לטעון את ההמחשה',
		'vzErrorLoadingMissingData': 'לא ניתן לטעון את ההמחשה, נתוני ההקשר חסרים',

		//Media (Video / Audio)
		'mediaWidgetTitle': 'פקד מדיה',
		'mediaPasteLink': 'הדביקו את ה-URL ולחצו על Enter כדי לשמור אותו',
		'videoHeight': 'גובה:',
		'videoWidth': 'רוחב:',
		'propMediaLink': 'קישור מדיה',
		'propMediaTitle': 'כותרת מדיה',
		'propMediaTitleDescription': 'כותרת המדיה',
		'propMediaTop': 'תכונות מדיה',
		'mediaMissingUrl': 'ה-URL של קישור המדיה חסר',
		'mediaUrlValidationError': 'ה-URL של קובץ המדיה אינו חוקי',
		'mediaUnknownValidationError': 'סוג מדיה זה אינו נתמך',
		'mediaHttpValidationError': 'יש לגשת אל קובץ המדיה באמצעות קישור HTTPS להצגה בדפדפן',

		// Properties pane
		'commonPropertiesLabel': 'תכונות',

		// Data strip
		'dataSetsLabel': 'ערכת נתונים',
		'dataViewsLabel': 'תצוגה',
		'columnQuality': 'איכות נתונים',
		'columnProperties': 'תכונות נתונים',

		'dataQuality': 'איכות נתונים',
		'dataQualityRowCount': 'מספר שורות',
		'dataQualityDistribution': 'התפלגות',
		'dataRowLabel': 'נתונים',

		// Timeline strip
		'storytellingSceneLabel': 'סצנה',
		'storytellingAddSceneLabel': 'הוספת סצנה חדשה',
		'storytellingInsertSceneLabel': 'הכנסת סצנה חדשה',
		'storySceneSingleCountLabel': '1 סצנה',
		'storySceneCountLabel': '%{count} סצנות',
		'storySceneRangeCountLabel': 'סצנה %{index} מתוך %{count}',
		'storySceneExpand': 'פתיחת ציר זמן',
		'storySceneActionMenu': 'שיגור תפריט אפשרויות סצנה',

		'timelineRightContainerLabel': 'קבוצת בקרי של לחצני ציר זמן',
		'timelineViewLabel': 'ציר זמן',
		'timelineZoomFit': 'זום להתאמה',
		'timelineZoomIn': 'קירוב',
		'timelineZoomOut': 'הרחקה',
		'timelineLeftHandle': 'ידית שמאלית',
		'timelineRightHandle': 'ידית ימנית',
		// object is timelineLeftHandle, timelineRightHandle or the title of the widget
		'timelineMoveLeft': 'העברת %{object} שמאלה',
		'timelineMoveRight': 'העברת %{object} ימינה',
		'timelinePositionIndicatorMoveLeftTo': 'מחוון מיקום של ציר זמן העברה שמאלה אל %{position}',
		'timelinePositionIndicatorMoveRightTo': 'מחוון מיקום של ציר זמן העברה ימינה אל %{position}',

		// Admin UI
		'adminTitle': 'מנהלה',
		'adminAccount': 'חשבון',
		'adminConnCreate': 'יצירת חיבור חדש',
		'adminConnEdit': 'עריכת חיבור',
		'adminConnTest': 'בדיקת חיבור',
		'adminConnTestButton': 'בדיקה',
		'adminConnTestConnection': 'נא לציין הסמכות עבור החיבור %{name}:',
		'adminConnTestFailed': 'נכשל',
		'adminConnTestFailure': 'לא ניתן להתחבר אל מסד הנתונים <i>%{name}</i>.‏ עיינו בהודעה שהתקבלה ממסד הנתונים ונסו לתקן את הבעיה.',
		'adminConnTestFailureDetailsLess': 'הסתרת פרטים',
		'adminConnTestFailureDetailsMore': 'הצגת פרטים',
		'adminConnTestFailureLess': 'פחות',
		'adminConnTestFailureMore': 'יותר',
		'adminConnTestInProgress': 'בדיקה',
		'adminConnTestSuccess': 'הצליח',
		'adminDataConnections': 'חיבורי נתונים',
		'adminSecureGateway': 'שערים מאובטחים',
		'adminEmail': 'דואל ליצירת קשר',
		'adminFullname': 'שם מלא',
		'adminRole': 'תפקיד',
		'adminScxRole': 'תפקידי מינוי',
		'adminSignonUnchanged': 'זיהוי המשתמש מוגדר, ערכו כדי לשנות.',
		'adminUserId': 'זיהוי משתמש',
		'adminUserProfile': 'פרופיל משתמש',
		'adminUsers': 'משתמשים',
		'adminFirstName': 'שם פרטי',
		'adminLastName': 'שם משפחה',
		'adminErrorTitle': 'מצטערים',
		'adminServiceError': 'השרת או השירות הפסיקו להגיב. נסו שוב מאוחר יותר.',
		'adminServiceInviteConflict': 'לא ניתן לשלוח את ההזמנה.  מצב כזה נוצר אם המשתמש כבר הוזמן אך עדיין לא נענה להזמנה. או יתכן שהמשתמש נמחק מהחשבון.',
		'scxServerNotAvailable': 'שירות מנהלת המינויים אינו זמין כרגע.',

		'adminSelectRoleTitle': 'בחירת תפקיד',
		'adminLastAdminErrorTitle': 'לא ניתן לשנות את התפקיד',
		'adminLastAdminError': 'יש רק משתמש אחד בתפקיד מנהלן. \n\nחייב להיות לכם לפחות משתמש אחד בתפקיד מנהלן.',

		// Admin account
		'adminSubscriptionLabel': 'מינוי',
		'adminSubscriptionVersion': 'אתם מנויים כרגע על <b>%{version}</b>.',
		'adminSubscriptionUpgrade': '<a href="" target="_blank" class="upgradeLink"><span class="wfg_add"></span>אפשרויות עריכה</a> עבור שטח אחסון, רישיונות ומנויים.',
		'adminSubscriptionLearnMore': 'קבלו מידע נוסף על אפשרויות מינויים אחרות.',
		'adminPurchasesLabel': 'רכישות',
		'adminTotalSpaceLabel': 'שטח כולל',
		'adminSpaceInfo': 'גודל הטעינה המרבי שלכם הוא %{maxUpload} ומספר העמודות המרבי המותר בערכת הנתונים שלכם הוא %{numCols} עמודות.',
		'adminAvailableLabel': 'זמין',
		'adminUsedLabel': 'בשימוש',
		'adminTotalLabel': 'סך הכל',
		'adminLicensesLabel': 'רישיונות',
		'adminEditLabel': 'עריכה',
		'adminPromoCodeLabel': 'קוד מבצע',
		'adminAccountError': 'לא ניתן לאחזר את פרטי החשבון. נסו שוב מאוחר יותר.',
		'adminUnitsB': 'B',
		'adminUnitsBLabel': '%{value} B',
		'adminUnitsKB': 'KB',
		'adminUnitsKBLabel': '%{value} KB',
		'adminUnitsMB': 'MB',
		'adminUnitsMBLabel': '%{value} MB',
		'adminUnitsGB': 'GB',
		'adminUnitsGBLabel': '%{value} GB',
		'adminUnitsTB': 'TB',
		'adminUnitsTBLabel': '%{value} TB',
		'adminUnitsPB': 'PB',
		'adminUnitsPBLabel': '%{value} PB',
		'adminOperatorPrefix': '%{prefix} %{value}',
		'adminUnknown': 'לא ידוע',
		'adminNoPurchases': 'לא נמצאו רכישות',

		// Admin UI - Users tab
		'adminUserDelete': 'האם אתם בטוחים שברצונכם למחוק משתמש זה?', // to_review
		'adminUsersDelete': 'אתם בטוחים שברצונכם למחוק משתמשים אלה?', // to_review
		'adminUsersDeleteFailDesc': 'שגיאות במחיקת משתמשים.', // to_review
		'adminUsersDeleteFailTitle': 'שגיאת מחיקה', // to_review
		'adminUsersDeleteSuccessDesc': 'המשתמשים נמחקו בהצלחה.', // to_review
		'adminUsersDeleteSuccessTitle': 'הושלם בהצלחה!', // to_review

		'adminUsersHeadingName': 'שם',
		'adminUsersHeadingStatus': 'מצב',
		'adminUsersHeadingLastModified': 'שינוי אחרון',
		'adminUsersInviteLabel': 'הזמנת משתמש',
		'adminUsersManageAccountsLabel': 'ניהול חשבונות משתמש',

		'adminDropHere': 'שחררו את קובץ ‎.csv שלכם כאן או הקישו כדי לעיין',

		'adminInviteCancelled': 'משתמש זה לא הוזמן עדיין. הבקשה בוטלה.',
		'adminInviteCount': 'בחרתם %{count} משתמשים (מקסימום %{max})',
		'adminInviteDisclaimer': '* באפשרותכם להזמין %{count} משתמשים בכל פעם',
		'adminInviteErrorCode': '[Error %{errorcode}]',
		'adminInviteErrorLine': '%{email} - %{reason} %{action} %{errorcode}',
		'adminInviteInProgress': 'הזמנת משתמשים...‏',
		'adminInviteCancelDesc': 'ביטול...‏',
		'adminInviteCancelTitle': 'ביטול',
		'adminInviteFailDesc': 'התגלו %{count} שגיאות.<br>עיינו בהודעות שלהלן כדי לקבוע אילו הזמנות משתמשים נכשלו.',
		'adminInviteFailTitle': 'לא כולם הוזמנו',
		'adminInviteOverLimit': 'משתמש זה לא הוזמן עדיין. תוכלו להזמין עד %{count} משתמשים בכל פעם, ומשתמש זה חרג מהמגבלה.',
		'adminInviteSuccessCount': '%{count} מתוך %{selectedCount} המשתמשים שבחרתם הוזמנו בהצלחה.',
		'adminInviteTryAgain': 'הקישו על \'הזמנת משתמשים שנטענו שוב" כדי להזמין את %{count} המשתמשים הבאים.',
		'adminInviteServerError': 'שגיאת שרת (%{errorcode}). נא לנסות שוב.',
		'adminInviteSuccessDesc': 'המשתמשים הוזמנו בהצלחה.',
		'adminInviteSuccessTitle': 'הושלם בהצלחה!',

		'adminUpload': 'טעינת נתונים',
		'adminUploadDesc': 'כדי להזמין משתמשים מרובים, צרו קובץ ‎.csv או שמרו גליון אלקטרוני כסוג הקובץ <b>CSV</b>.‏<br><br>קובץ ה-CSV חייב לכלול 3 עמודות בסדר הזה: כתובת דואל, שם פרטי ושם משפחה.<br>אין לכלול עמודות אחרות.',
		'adminUploadHelpLink': 'מידע נוסף',
		'adminUsersDeleteAll': 'מחיקת משתמשים',
		'adminUsersInviteAll': 'הזמנה משתמשים שנטענו',
		'adminUsersUpload': 'טעינת משתמשים',

		'adminUploading': 'טעינת נתונים...‏',
		'adminUploadErrorLine': 'שורה %{line}: %{reason}',
		'adminUploadSuccess': 'הושלם בהצלחה!',
		'adminUploadSuccessDesc': 'הקובץ \'%{name}\' נטען בהצלחה.',
		'adminUploadFailCount': 'נמצאו %{failedCount} שגיאות בקובץ שלכם.',
		'adminUploadFailDesc': 'ודאו שאין  שדות ריקים ושכל כתובות הדואל חוקית <br><br>בדקו את הקובץ שלכם והגישו שוב.',
		'adminUploadFailTitle': 'לא ניתן לטעון את הקובץ שלכם',

		'adminUserStatus_PRELOAD': 'עדיין לא הוזמן',
		'adminUserStatus_INVITATION_PENDING': 'הוזמן',
		'adminUserStatus_INACTIVE_PENDING': 'הוזמן אך לא הופעל',
		'adminUserStatus_ACTIVE': 'פעיל',
		'adminUserStatus_INACTIVE_SUSPENDED': 'מושעה',

		// Data connection parameters  (for the values returned by /externalconnections/types. 'conn_' + [parameter name]
		'conn_biurl': 'URL',
		'conn_dbname': 'שם מסד נתונים',
		'conn_dbtypeid': 'סוג מסד נתונים',
		'conn_host': 'שם שרת',
		'conn_name': 'שם חיבור',
		'conn_password': 'סיסמה',
		'conn_password_confirm': 'אישור סיסמה',
		'conn_port': 'מספר יציאה',
		'conn_port_validation': 'רק מספרים מותרים עבור היציאה.',
		'conn_schema': 'סכימת מסד נתונים',
		'conn_signon': 'הכללת שם התחברות',
		'conn_ssl': 'שימוש ב-SSL',
		'conn_sslcertificate': 'אישור SSL ‏(אופציונלי)',
		'conn_sslcertificate_set': 'אישור SSL מוגדר, ערכו כדי לשנות.',
		'conn_url': 'פרמטרים של חיבור JDBC (אופציונלי)',
		'conn_user': 'זיהוי משתמש',

		// Data Connection types  (for the values returned by /externalconnections/types. 'connType_' + [name]
		'connType_Cognos_BI': 'שרת IBM Cognos BI',
		'connType_IBM_DB2': 'IBM DB2',
		'connType_MySQL': 'MySQL',
		'connType_Oracle': 'Oracle',
		'connType_Postgres': 'PostgreSQL',
		'connType_SQLDB': 'IBM SQL Database for Bluemix',
		'connType_SQL_Server': 'Microsoft SQL Server',
		'connType_dashDB': 'IBM dashDB',

		'bi_connect_error': 'קובצי חיבור עדיין לא הותקנו בתיקיה הדרושה בשרת IBM Cognos BI.‏<br><br>פנו אל מנהלן IBM Cognos BI,‏ שיוכל להפעיל את החיבור. כדי לקבל מידע נוסף, ראו <a class="wah-anchor" href="https://watson.analytics.ibmcloud.com/docs/help/#wa_an_overview/wa-an-admin-dataconn-c10_admin.html" target="_blank">Docs</a>.‏',
		'bi_notrunning_error': 'לא ניתן לתקשר עם שרת IBM Cognos BI באמצעות ה-URL שסיפקתם.<br><br>ודאו שה-URL נכון. ראו את <a class="wah-anchor" href="https://watson.analytics.ibmcloud.com/docs/help/#wa_an_overview/wa_an_hlp_c10_conn_err.html" target="_blank">Docs</a> כדי לקבל מידע על סיבות אפשריות אחרות לכך שאינכם יכולים להתחבר.',
		'bi_info': 'השרת חייב להשתמש בפרוטוקול אינטרנט מאובטח וה-URL חייב להתחיל עם https.‏<br>לדוגמה, https:///ibmcognos bi_server.example.com',

		'dbTypeRestrictionLabel': 'עם המינוי שלכם, תוכלו ליצור ולהשתמש בחיבורים רק סוג מסד נתונים אחד בכל פעם.<br><br>כדי להתחבר לסוג מסד נתונים אחר, מחקו את כל חיבורי מסד הנתונים, ולאחר מכן צרו חיבורים חדשים.&nbsp;&nbsp;כדי להתחבר אל סוגים מרובים של מסדי נתונים באותו הזמן, שדרגו את המינוי שלכם. ',

		// Modelling UI
		'typeColumn': 'סוג',
		'modellingColumnType': 'סוג',
		'modellingColumnAggregation': 'צבירה',
		'modellingColumnUsage': 'שימוש',
		'modellingColumnSort': 'מיון',
		'modellingColumnFormat': 'מבנה',
		'modellingColumnCategory': 'קטגוריה',

		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		'modellingLoading': 'טעינה מתבצעת...‏',

		'modellingProcessing': 'עיבוד מתבצע...‏',
		'modellingImport': 'יבוא',
		'modellingReimport': 'יבוא חוזר',
		'modellingDatasourceTitle': 'מקור נתונים',
		'modellingImportStartedTitle': 'היבוא התחיל',
		'modellingImportStartedText': 'יבוא הנתונים עשוי להימשך זמן מה.\n\n (ניתן ליצור תצוגה בזמן שהנתונים מיובאים.)',
		'importDatasourceTitle': 'חיבורים',
		'dropHere': 'שחררו כאן כדי ליצור מקור נתונים חדש...‏',
		'browseButton': 'עיון',
		'errorNoData': 'אין נתונים לעיבוד.',
		'errorNoFile': 'אין קובץ לטעינה.',
		'errorUploadFailed': 'לא ניתן לטעון.',
		'uploadSucceessful': 'הטעינה הצליחה',
		'del_datasourceTitle': 'מחיקת ערכת נתונים',
		'del_datasourceMsg': 'אתם בטוחים שברצונכם למחוק את \'%{name}\'?‏',
		'modellingFileUpdate': 'עדכון',
		'modellingFileUpdateTitle': 'עדכון ערכת נתונים',
		'modellingFileUpdateDescription': 'האם ברצונכם לעדכן את \'%{name}\'?‏',
		'modellingFileUpdatingTitle': 'עדכון \'%{name}\'',
		'modellingUpdateStartedTitle': 'יבוא העדכון התחיל',
		'modellingUpdateStartedText': 'עדכון הנתונים עשוי להימשך זמן מה.\n\n (ניתן ליצור תצוגה בזמן שהנתונים מעודכנים.)',
		'modellingErrorImportUploadNoFile': 'אין קובץ לטעינה.',
		'modellingErrorImportUploadFailed': 'לא ניתן לטעון.',
		'modellingErrorImportUploadInvalidType': 'סוג הקובץ אינו חוקי.',
		'modellingErrorImportUploadTableFailed': 'לא ניתן לקבל טבלאות.',
		'modellingIntentResultsTitle': 'בחרו את ערכת הנתונים המוצעת לשימוש',
		'modellingColumnViewRelationships': 'הצגת טבלאות קשורות',
		'modellingTableRelatedTables': 'טבלאות הקשורות אל \'%{name}\'',
		'modellingTable': '%{name} - טבלה',
		'modellingColumnIncludedInDataSet': 'נוסף',
		'modellingDataSet': 'ערכת נתונים',
		'modellingViewInDataSet': 'הצגה בערכת הנתונים',
		'modellingViewRelatedTables': 'הצגת פריטים קשורים',

		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		'modellingRelatedTablesNoneFound': 'לא נמצאו טבלאות קשורות',

		'modellingValidatingDataset': 'אימות...‏',
		'datasetFinishedRefreshing': 'ערכת הנתונים %{datasetName} רועננה.',



		// Join UI - Navigation Controller titles
		'modellingJoinTable': 'פענוח נתיב צירוף:',
		'modellingJoinColumns': 'הגדרת נתיב צירוף עבור הטבלה: %{name}',
		'modellingJoinToTable': 'צירוף עם הטבלה: %{name}',

		// Data Quality
		'excluded': 'סונן',
		'metricPrefixThousand': 'K',
		'metricPrefixMillion': 'M',
		'metricPrefixBillion': 'B',
		'metricPrefixTrillion': 'T',
		'metricPrefixQuadrillion': 'Q',

		//Column Flyout
		'modellingColumnFilter': 'מסנן',
		'modellingColumnSortNone': 'ניקוי המיון',
		'modellingColumnSortAsc': 'מיון עולה',
		'modellingColumnSortDesc': 'מיון יורד',
		'modellingColumnRemove': 'סילוק עמודה זו',

		// Import File Browser
		dropboxPageTitle: 'חיבור ‏Dropbox חדש',
		sizeColumn: 'גודל',

		//Modelling Column Property Values
		'dataType_string': 'מחרוזת',
		'dataType_date': 'תאריך',
		'dataType_integer': 'מספר שלם',
		'dataType_double': 'כפול',
		'dataType_float': 'נקודה צפה',
		'dataType_boolean': 'בוליאני',

		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		'defaultAggregation_count': 'ספירה',
		'defaultAggregation_countdistinct': 'ספירה נבדלת',
		'defaultAggregation_max': 'מקסימום',
		'defaultAggregation_min': 'מינימום',
		'defaultAggregation_avg': 'ממוצע',
		'defaultAggregation_sum': 'סכום',
		'defaultAggregation_auto': 'אוטומטי (%{aggregationType})',

		'type_fact': 'עובדה',
		'type_attribute': 'מאפיין',

		'defaultSort_none': 'לא למיין',
		'defaultSort_asc': 'מיון עולה',
		'defaultSort_desc': 'מיון יורד',

		'category_none': 'ללא',
		'category_location': 'מיקום',
		'category_monetary': 'מוניטרי',
		'category_time': 'שעה',

		// Root menu
		rootMenuTitle: 'תפריט ראשי',

		errorMessageTitle: 'שגיאה',
		errorMessageDetails: 'פרטים: ',
		errorMessageTitleAssetAlreadyExists: 'הנכס כבר קיים',

		defaultTabTitle: 'לשונית %{index}',
		tabAddBtnTitle: 'הוספת לשונית חדשה',


		// Homepage View
		nameColumn: 'שם',
		creatorColumn: 'נוצר על ידי',
		creationDateColumn: 'תאריך יצירה',
		versionColumn: 'גרסה',
		modifiedColumn: 'שינוי אחרון',

		filterBy: 'סינון פריטים',
		allFilter: 'כל הפריטים',
		createdByMeFilter: 'נוצר על ידי',
		sharedWithMeFilter: 'שותף אתי',
		favoritesFilter: 'המועדפים שלי',
		recentsFilter: 'נוספו לאחרונה',
		sortBy: 'מיון לפי',

		// Sort Menu
		sortModified: 'שונה',
		sortUpdated: 'עודכן',
		sortName: 'שם',

		viewAs: 'הצגה בתור',
		thumbnailsView: 'הצגה כתמונות ממוזערות',
		listView: 'הצגה כרשימה',
		createMenu: 'יצירה',
		newAppItem: 'לוח מחוונים',
		newDataSet: 'ערכת נתונים',
		newStory: 'סיפור',

		menuSelectionState_a11y: 'בורר "%{item}" הוגדר בתור "%{selectedItem}"',

		unableToShareItem: 'לא ניתן לשתף את הפריט "%{item}".',
		toastFetchingContent: 'אחזור תוכן נוסף...‏',
		unableToGetData: 'לא ניתן לקבל תוכן.',
		unableToFavorite: 'לא ניתן לשנות את מצב המועדף.',
		hpErrorMissingRequiredOptions: 'אפשרויות אתחול דרושות חסרות',
		unableToOpenBoard: 'לא ניתן לפתוח את "%{name}".',
		unableToDuplicateBoard: 'לא ניתן לשכפל את "%{name}".',
		unableToCreateBoard: 'לא ניתן ליצור את "%{name}".',
		unableToCreateBoardNameConflict: 'נכס באותו שם כבר קיים.',

		// DataSet Detail View
		status: 'מצב',
		numberOfRows: 'שורות',
		importWarnings: 'אזהרות',
		lineNumbers: 'שורות',
		excerptFromSource: 'תמצית',
		reason: 'סיבה',
		numberOfRowsDropped: 'שורות שבוטלו',
		oneRowDropped: '1 שורה בוטלה',

		// Type Menu
		typeMenuLabel: 'סוג',
		dashboardsLabel: 'לוחות מחוונים',
		datasetsLabel: 'ערכות נתונים',
		storiesLabel: 'סיפורים',
		allLabel: 'כל הסוגים',

		// Board Page View App Bar
		datasets: 'ערכות נתונים',
		settings: 'תכונות',
		add: 'הוספה',
		widgets: 'פקדים',
		dashboardProperties: 'תכונות לוח מחוונים',
		storyProperties: 'תכונות סיפור',
		pins: 'אוסף',
		pinsOld: 'הנעיצות שלי',
		// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
		// See https://github.com/airbnb/polyglot.js#pluralization
		pinCount: '%{smart_count} נעיצה |||| %{smart_count} נעיצות',
		pinSearch: 'חיפוש',
		pinSearchOld: 'חיפוש נעיצות',
		pinListView: 'תצוגת רשימה',
		pinIconView: 'תצוגת איקונים',
		pinRemove: 'סילוק',
		pinCreate: 'יצירה',
		pinDeleteError: 'לא ניתן למחוק נכס אחד או יותר מהאוסף. נסו שוב מאוחר יותר.',
		pinDeleteErrorOld: 'לא ניתן למחוק נעיצה אחת או יותר. נסו שוב מאוחר יותר.',
		pinRetrieveError: 'לא ניתן לאחזר נעיצה אחת או יותר. נסו שוב מאוחר יותר.',
		NoPinsCollected: 'אין המחשות נעוצות',
		pinDeletedToast: 'הנעיצה סולקה',
		pinAddedToast: 'הנעיצה נוספה בהצלחה אל \'הנעיצות שלי\'',
		pinDateFilter: 'מסנן תאריכים',
		pinDateFilterAll: 'הכל',
		pinDateFilterToday: 'היום',
		pinDateFilterYesterday: 'אתמול',
		pinDateFilterPastWeek: 'השבוע האחרון',
		pinDateFilterPastMonth: 'החודש האחרון',
		pinDateFilterEarlier: 'מוקדם יותר',

		//Story scene toolbar
		toolbarActionTimeline: 'הגדרת ציר הזמן של הסצנה',

		// data widget contextual toolbar labels
		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		toolbarActionSort: 'מיון',
		toolbarActionSortAscending: 'מיון עולה',
		toolbarActionSortDescending: 'מיון יורד',
		toolbarActionSortAuto: 'אוטומטי (%{sortOrder})',
		toolbarActionFormat: 'מבנה',
		toolbarActionFormatAbbreviation: 'קיצור',
		toolbarActionFormatNone: 'אוטומטי',
		toolbarActionFilter: 'מסנן',
		toolbarActionTopBottom: 'ראש או תחתית',
		toolbarActionAddShape: 'הוספת צורה',
		toolbarActionRmvShape: 'סילוק צורה',
		toolbarActionToggleShapeDrop: 'צורה אינפוגרפית',
		toolbarActionToggleShapeDropTitle: 'יצירת אינפוגרפיקה',
		toolbarActionToggleShapeDropText: 'גררו צורה לשדה זה כדי ליצור אינפוגרפיקה.',
		toolbarActionAggregationType: 'סיכום',
		toolbarDeleteActionText: 'סילוק עמודה',
		toolbarActionFilterLocalKeepSelected: 'השארה',
		toolbarActionFilterLocalExcludeSelected: 'סינון',
		toolbarActionFilterAllKeepSelected: 'מסנן',
		toolbarActionSimpleCalculation: 'חישוב פשוט',
		toolbarActionDrillBack: 'אחורה',
		toolbarActionDrillUp: 'עליית רמה',
		toolbarActionDrillDown: 'ירידת רמה',
		toolbarActionNavigate: 'ניווט',
		toolbarActionCreateFilterGroup: 'יצירת חיבור חדש',
		toolbarActionDisconnectFilterGroup: 'שבירת כל הקישורים',
		toolbarActionLinkFilterGroup: 'הוספה לחיבור קיים',

		toolbarLabel: '%{labelName}:',
		toolbarNoValueLabel: '%{labelName}',

		// Side bar
		'sidebarAdd': 'הוספה',
		'sidebarMultiselect': 'מיתוג בחירה של פריטים מרובים',

		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		'multiselectMsg': '%{count} נבחרו',

		'multiselectWithTotalMsg': '%{count} מתוך %{total}',
		'sidebarGoBack': 'חזרה',

		//DataSet pane
		errorLoadingDataSets: 'לא ניתן לטעון ערכת נתונים זו',
		errorLoadingDataSetMetaData: 'לא ניתן לטעון ערכת נתונים זו',
		'dataSetPaneLastUpdated': 'עדכון אחרון: %{date}',
		'dataSetPaneDateUnknown': 'לא ידוע',
		'sourcePaneLabel': 'מקורות שנבחרו',
		'addSourceLabel': 'הוספה כמקור',
		'intentSearchLabel': 'חיפוש כוונה',
		'find_label': 'איתור',
		'navigationPathsLabel': 'נתיבי ניווט',

		//widgetlist
		errorLoadingWidgetList: 'לא ניתן לטעון את האובייקטים.',
		errorLoadingThemeFile: 'לא ניתן לטעון את הגדרת הערכה.',
		errorLoadingLayoutFile: 'לא ניתן לטעון את התצוגה.',

		//data widget

		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		dwErrorLoadingAvailableVisualizations: 'לא ניתן לטעון את הגדרות ההמחשות הזמינות',

		dwErrorLoadingVisualizationNotFound: 'לא ניתן לטעון את האובייקט, משום שחסרה בו הגדרת המחשה',
		dwErrorLoadingVisualizationListNotFound: 'לא ניתן לטעון את ההמחשה.',
		dwErrorRunningQuery: 'לא ניתן לאחזר את הנתונים מערכת הנתונים %{datasetName}.',
		dwErrorGeoData: 'יש בעיה בהצגת הנתונים הגאוגרפיים במפה. נא לבחור סוג המחשה אחר. ',
		dwPromptSignonCancelWarning: 'הנתונים עבור המחשה זו אינם זמינים. ספקו את ההסמכות הנכונות.',
		dwErrorMissingDataset: 'לא ניתן לטעון ההמחשה, מפני שערכת הנתונים המשויכת שלה \'%{datasetName}\' אינה זמינה.',
		dwErrorRenderingVisualization: 'לא ניתן לטעון המחשה זו.',
		dwErrorVisualizationTooSmall: 'ההמחשה קטנה מדי ולא ניתן להציג את הנתונים שהיא מכילה. הגדילו את ההמחשה או הגבילו את הנתונים שהוא מכיל.',
		aria_label_datatable: 'טבלת נתונים',
		aria_key_navi_datatable_desc: 'השתמשו במקשי החצים כדי לנווט לכל תא. לחצו על מקש Control ועל מקש Home כדי לעבור להשורה הראשונה, ועל מקש Control ועל מקש End כדי לעבור לשורה האחרונה.',
		geomapUnrecognizedLocations: 'מיקומים לא מזוהים:',
		geomapAmbiguousLocations: 'אזורים רב-משמעיים:',

		// custom widget
		customWidget: 'פקד מותאם',
		noCustomWidgets: 'אין פקדים מותאמים',

		// Action names
		'toggleContextBar': 'מיתוג סרגל ההקשר',
		'delete': 'מחיקה',
		'share': 'שיתוף',
		'unshare': 'ביטול שיתוף',
		'rename': 'שינוי שם',
		'close': 'סגירה',
		'duplicate': 'שכפול',
		'copyOf': 'עותק של %{name}',

		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		'retry': 'נסיון חוזר',

		'changeTemplate': 'שינוי תבנית',

		// Aggregation Types
		'sum': 'סכום',
		'count': 'ספירה',
		'countdistinct': 'ספירה נבדלת',
		'avg': 'ממוצע',
		'min': 'מינימום',
		'max': 'מקסימום',
		'custom': 'מותאם',
		'calculated': 'מחושב',

		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

		//simple calculation
		'percDifferenceOp': '% שינוי',
		//For example, Profit - Expenses
		'calculationTitle': '%{col1} %{operator} %{col2}',

		'quickadd': 'מה ברצונכם לראות? לדוגמה, הכנסות לפי שנה.',
		'templateWidgetPlaceholderInput': 'קריטריונים להמחשה...‏',
		'QuickAddResultsHeader': 'המחשות נתונים',
		'NoQuickAddResults': 'לא נמצאו התאמות לכוונה שלכם. ליצור ערכת נתונים חדשה?',
		'NoQuickAddResultsRetry': 'לא ניתן למצוא התאמות. נסו שוב עם מונחי החיפוש שונים.',
		'templateWidgetTitle': 'תבנית',

		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		nullValueLabel: '(ריק)',

		nullValueContent: '(ללא ערך)',

		// Modelling / Data Shaping
		textFilterControlRegionLabel: 'מסנן תמליל - %{columnName}',

		textFilterSelectTab: 'בחירה',

		textFilterConditionTab: 'הגדרת תנאי',
		textFilterItemsSelected: '(%{selected})',

		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		textFilterItemsNotFound: 'אין פריטים זמינים.',

		textFilterEquals: 'שווה',
		textFilterContains: 'מכיל',
		textFilterBeginsWith: 'מתחיל עם',
		textFilterEndsWith: 'מסתיים עם',
		textFilterDoesNotEqual: 'אינו שווה',
		textFilterDoesNotContain: 'אינו מכיל',
		textFilterDoesNotBeginWith: 'אינו מתחיל עם',
		textFilterDoesNotEndWith: 'אינו מסתיים עם',
		textFilterSampleText: 'לדוגמה: A',

		textFilterAndButton: 'וגם',
		textFilterOrButton: 'או',

		dateFilterMessage: 'בחרו טווח תאריכים',
		dateRangeControlRegionLabel: 'מסנן טווח תאריכים - %{columnName}',
		dateFilterRangeOption: 'אפשרות טווח',
		dateFilterDateLabel: 'תאריך',
		dateFilterBlank: '(ריק)',
		dateFilterBefore: 'לפני',
		dateFilterAfter: 'אחרי',
		dateFilterBetween: 'בין',
		dateFilterSampleText: 'YYYY-MM-DD',
		dateTitle: 'תאריך',
		dateIncludeBlankLabel: 'הכללת תאריך ריק',

		timeTitle: 'שעה',
		timeFilterMessage: 'בחרו טווח שעות',
		dateTimeFilterMessage: 'בחרו טווח של תאריכים ושעות',

		topbottomNumberOfResultsLabel: 'מספר תוצאות',
		topbottomNumberOfResultsLimit: 'בין %{lower}-%{higher}',
		topbottomSelectOption: 'אפשרות ראש או תחתית',
		topbottomOptionLabel: 'הצגה',
		searchByLabel: 'לפי',
		searchNoMatches: 'לא נמצאו התאמות',
		topbottomRankColumnLabel: 'הוספת עמודת דירוג לטבלה',
		topbottomNone: 'ללא',
		topCount: 'ספירת עליונים',
		topPercent: '% עליונים',
		bottomCount: 'ספירת תחתונים',
		bottomPercent: '% תחתונים',
		topbottomSearchColumn: 'איתור עמודה',
		searchColumnAriaLabel: 'איתור עמודה. הקלידו את שם העמודה לחיפוש, והשתמשו בחץ היורד כדי לאתר העמודה ברשימה.',
		rankColumnLabel: 'דירוג (%{columnLabel})',
		topbottomClearLabel: 'ניקוי',

		rangeFilterControlRegionLabel: 'מסנן טווח - %{columnName}',

		// Slider
		sliderRegionLabel: 'פקד מחלק, השתמש בחץ הימני והשמאלי להזזת ידיות המחלק.',
		sliderHandleLabel: 'ידית מחלק',
		a11ySliderHandleLabel: 'ידית מחלק %{sliderValue}',
		sliderInputLabel: 'ערך',

		// Refinery - Hidden columns
		datasetItemsUnavailable: 'חלק מפריטי ערכת הנתונים המשמשים בהמחשה זו אינם זמינים.',
		datasetItemUnavailable: 'פריט ערכת נתונים זה אינו זמין.',

		//Authoring topBottom
		topOperator: 'עליונים',
		bottomOperator: 'תחתונים',
		//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
		topBottomFact: '%{value} %{operator} לפי %{columnLabel}',
		//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
		topBottomDimension: '%{value} %{operator}',
		topBottomTitle: 'אובייקט זה בלבד',
		deleteTopBottom: 'מחיקת ספירת עליונים או תחתונים',
		editTopBottom: 'עריכת ספירת עליונים או תחתונים',
		deleteDrillState: 'מחיקת מצב הרמה הנוכחי',
		ariaDeleteDrillStateLabel: 'לחצו על Enter כדי לערוך את ספירת העליונים או התחתונים.',
		drillUpStateTitle: 'עליית רמה',
		drillDownStateTitle: 'ירידת רמה',
		ariaEditTopBottomLabel: 'לחצו על Enter כדי לערוך את ספירת העליונים או התחתונים.',
		ariaDeleteTopBottomLabel: 'לחצו על מקש DELETE כדי למחוק את ספירת העליונים או התחתונים.',

		// Authoring filtering
		dimFilterIn: 'כולל: %{in}',
		dimFilterNotIn: 'לא כולל: %{out}',
		measureFilterBetween: 'בין %{lowerBound} לבין %{upperBound}',
		measureFilterNotBetween: 'לא בין %{lowerBound} לבין %{upperBound}',
		gtFilter: 'אחרי %{lowerBound}',
		ltFilter: 'לפני %{upperBound}',
		notGtFilter: 'לא אחרי %{lowerBound}',
		notLtFilter: 'לא לפני %{upperBound}',
		localFilterTitle: 'אובייקט זה בלבד',
		globalFilterTitle: 'כל האובייקטים',
		deleteFilter: 'מחיקת מסנן',
		editFilter: 'עריכת מסנן',
		ariaEditFilterLabel: 'לחצו על מקש ENTER כדי לערוך את המסנן.',
		ariaDeleteFilterLabel: 'לחצו על מקש DELETE כדי למחוק את המסנן.',

		// Prompts
		ariaEditPrompt: 'לחצו על מקש ENTER כדי לשנות את ערך ההנחיה.',

		moreDataIndicator: 'הנתונים שלכם נקצצו לכדי %{threshold} פריטים. החילו מסנן כדי להראות פחות.',

		// data point filtering
		dataPointFilterTitle: 'נקודות נתונים',
		dataPointFilterIncludeSummary: 'נכללו %{valueCount} נקודות נתונים',
		dataPointFilterExcludeSummary: 'סוננו %{valueCount} נקודות נתונים',

		// DB2 connection page
		db2Database: 'מסד נתונים של DB2 (%{jdbcConnection})',
		db2Title: 'התחברות אל IBM DB2',

		// Database
		databaseConnectionMessage: 'ציינו את פרטי החיבור למסד נתונים:',
		connectionString: 'מחרוזת חיבור למסד נתונים',
		databaseCredentials: 'הסמכות: ',
		databaseUserName: 'שם משתמש',
		databasePassword: 'סיסמה',
		databaseConnect: 'חיבור',

		// Twitter Keyword page
		twitterTitle: 'טוויטר',
		twitterKeywordMessage: 'ציינו מונח חיפוש:',
		twitterKeyword: 'מילת מפתח',
		twitterSearch: 'חיפוש',

		// NewConnectionView Providers
		twitterProvider: 'טוויטר',
		dropboxProvider: 'Dropbox',
		db2Provider: 'DB2',

		workbookCreateFailed: 'לא ניתן ליצור את התצוגה: %{error}\nהפעולה שנכשלה: %{lastOp}',

		// Expanded View, Focus View
		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		widgetFiltersLabel: 'פקד מסננים',
		missingColumn: 'חסר: %{columnLabel}',
		missingFiltering: 'חסרים מסננים בזיהויי העמודות שלהלן:',
		heatByLabel: 'חום לפי',
		'evCollapse': 'כיווץ',
		'evColumns': 'עמודות',
		'evLocalFilters': 'מסננים מקומיים',
		'evExpand': 'הרחבה',
		'evFilterTooltip': 'מסנן',
		'evAdd': 'הוספת עמודה',

		// Navigation View
		'navigationBack': 'אחורה',

		//Storytelling
		storyTellingDefaultSceneTitle: 'סצנה %{index}',
		storyTellingTabAddBtnTitle: 'הוספת סצנה חדשה',
		storyTellingOverviewBtnLabel: 'סקירה',
		storyTellingSelectSceneWarning: 'נא לבחור סצנה',

		storyTellingSceneAddBtnTitle: 'הוספת סצנה חדשה',
		storyTellingNumScenes: '%{index} סצנות',
		storyTellingTimelineDisabledInteraction: 'הקישו שוב כדי להשהות ולתפעל',

		timelineRecord: 'רשומה',
		timelineRecording: 'לכידת שינויים בתכונות...‏',
		timelinePlay: 'הרצה',
		timelinePause: 'השהיה',
		sceneStart: 'קפיצה לתחילת הסצנה',
		sceneEnd: 'קפיצה לסוף הסצנה',
		sceneNavigation: 'ניווט בסצנות',

		navNextScene: 'הסצנה הבאה',
		navPrevScene: 'הסצנה הקודמת',
		navPrevSceneAbbreviated: 'סצנה קודמת',
		navExitFullScreen: 'יציאה ממצב מסך מלא',
		navToggleOverview: 'מיתוג סקירה',
		fullscreen: 'כניסה למצב מסך מלא',
		fullscreenMenuLabel: 'מסך מלא',
		betaStorytelling_1: 'זהו מאפיין בטא והוא כפוף לתנאי השימוש הנמצאים ',
		betaStorytelling_2: 'כאן',
		betaStorytelling_3: '. השימוש במאפיין בטא זה מהווה הסכמה לתנאים אלה.',
		betaDialog: 'Technology Preview Code (TPC) provided with the IBM SaaS are not part of the IBM SaaS.‎ TPC is provided under the same terms as the IBM SaaS, except as provided below.‎ Some or all of the TPC may not be made generally available by IBM as or in a product or offering.‎ You are permitted to use TPC only for internal use for evaluation purposes and not for use in a production environment.‎ You may use the TPC until IBM withdraws the TPC or terminates access to it.‎ IBM provides the TPC without obligation of support and "AS IS," WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, THE WARRANTY OF TITLE, NON-INFRINGEMENT OR NON-INTERFERENCE AND ANY IMPLIED WARRANTIES AND CONDITIONS OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.‎ You should take precautions to avoid any loss of data that might result when the TPC can no longer be used.‎ You agree IBM may use all feedback and suggestions you provide.‎ ',

		//time journey
		'sceneListStart': 'התחלה',
		'sceneListEnd': 'סוף',

		// Pinning
		'contentPinFail': 'לא ניתן לאסוף את התוכן. נסו שוב מאוחר יותר.',
		'contentPinFailOld': 'לא ניתן לנעוץ את התוכן. נסו שוב מאוחר יותר.',

		// Layouts
		'dropZoneLabel': 'שחררו כאן כדי להגדיל',

		//Share
		shareDefaultPageTitle: 'דף %{index}',
		shareDefaultStoryPageTitle: 'סצנה %{index}',

		nextPage: 'הדף הבא',
		previousPage: 'הדף הקודם',

		assetAssembly: 'תצוגה',
		assetStory: 'סיפור',

		toolbar_save: 'שמירה',
		brgr_saveAs: 'שמירה בשם',
		brgr_refresh: 'רענון',

		// Save
		saving: 'שמירה...‏',
		save_success: 'התצוגה שלכם נשמרה.',
		save_failure: 'אירעה בעיה. לא ניתן לשמור את התצוגה שלכם. נסו שוב מאוחר יותר.',
		dashboard_save_success: 'לוח המחוונים שלכם נשמר.',

		geminiLeave: 'אתם עומדים לעזוב את IBM Watson Analytics.‏',

		warning: 'אזהרה',
		missingDataSetData: 'הנתונים עבור ערכת נתונים זו אינם זמינים. רעננו את ערכת הנתונים או פנו למנהלן כדי לקבל גישה למקור.',

		// Calculations
		error_calculation_in_use: 'חישוב שנבחר נמצא בשימוש ואי אפשר למחוק אותו.',

		resize: 'שינוי גודל',
		rotate: 'סיבוב',
		moveHandle: 'העברת פקד',
		expandHandle: 'הרחבה',
		panHandle: 'גלילה',

		//Navigation
		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		navigateTitle: 'ניווט אל',

		// Slide out titles
		shapeSlideoutTitle: 'צורות',
		textSlideoutTitle: 'תמליל',
		mediaSlideoutTitle: 'מדיה',
		visualizationSlideoutTitle: 'המחשות חזותיות',

		// Board Model Dialog Messages
		invalidJSONResponse: 'קוד JSON שסופק אינו חוקי. ראו מידע נוסף ביומן השגיאות.',

		// Widget type labels
		shape_label: 'צורה',
		image_label: 'תמונה',
		data_label: 'תרשים',
		media_label: 'מדיה',
		text_label: 'תמליל',
		embedMedia_label: 'מדיה',
		youtube_label: 'סרטון של YouTube',
		webpage_label: 'דף רשת',

		// **** Smart names for objects ****
		// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
		one_name: '%{name}',
		one_name_numbered: '%{name} (%{number})',
		noExtraText_shape: 'צורה',
		noExtraText_shape_numbered: 'צורה (%{number})',
		few_shape: 'קבוצה של %{count} צורות',
		many_shape: 'קבוצה של %{count} צורות',
		// %{text} is the description of the image, specified in the properties by the user
		one_image: 'תמונה %{text}',
		one_image_numbered: 'תמונה %{text} (%{number})',
		noExtraText_image: 'תמונה',
		noExtraText_image_numbered: 'תמונה (%{number})',
		few_image: 'קבוצה של %{count} תמונות',
		many_image: 'קבוצה של %{count} תמונות',
		noExtraText_text: 'תיבת תמליל ריקה',
		noExtraText_text_numbered: 'תיבת תמליל ריקה (%{number})',
		few_text: 'קבוצה של %{count} תיבות התמליל',
		many_text: 'קבוצה של %{count} תיבות התמליל',
		// Crosstab: values by Row1 (and Column1)
		crosstab_opt_mapping: '%{values} לפי %{row_level1} ולפי %{column_level1}',
		crosstab_opt_mapping_numbered: '%{values} לפי %{row_level1} ולפי %{column_level1} ‏(%{number})',
		crosstab_has_mapping: '%{values} לפי %{row_level1}',
		crosstab_has_mapping_numbered: '%{values} לפי %{row_level1} ‏(%{number})',
		crosstab_no_mapping: 'טבלה מוצלבת ריקה',
		crosstab_no_mapping_numbered: 'טבלה מוצלבת ריקה (%{number})',
		crosstab_named: 'טבלה מוצלבת %{name}',
		crosstab_named_numbered: 'טבלה מוצלבת %{name} ‏(%{number})',
		// Grid: first column grid
		JQGrid_has_mapping: 'סריג %{grid_cols}',
		JQGrid_has_mapping_numbered: 'סריג %{grid_cols} ‏(%{number})',
		JQGrid_no_mapping: 'סריג ריק',
		JQGrid_no_mapping_numbered: 'סריג ריק (%{number})',
		JQGrid_named: 'סריג %{name}',
		JQGrid_named_numbered: 'סריג %{name} ‏(%{number})',
		// Hierarchy: level one hierarchy
		hierarchy_has_mapping: 'היררכיה של %{level1}',
		hierarchy_has_mapping_numbered: 'היררכיה של %{level1} ‏(%{number})',
		hierarchy_no_mapping: 'היררכיה ריקה',
		hierarchy_no_mapping_numbered: 'היררכיה ריקה (%{number})',
		hierarchy_named: 'היררכיה %{name}',
		hierarchy_named_numbered: 'היררכיה %{name} ‏{%{number})',
		// Legacy map: Region heat by Regions map
		map_has_mapping: 'מפה של %{categories}',
		map_has_mapping_numbered: 'מפה של %{categories} ‏(%{number})',
		map_no_mapping: 'מפה ריקה',
		map_no_mapping_numbered: 'מפה ריקה (%{number})',
		map_named: 'מפה %{name}',
		map_named_numbered: 'מפה %{name} ‏(%{number})',
		// Summary value: value summary value
		summary_has_mapping: 'ערך סיכום של %{values}',
		summary_has_mapping_numbered: 'ערך סיכום של %{values} ‏(%{number})',
		summary_no_mapping: 'ערך סיכום ריק',
		summary_no_mapping_numbered: 'ערך סיכום ריק (%{number})',
		summary_named: 'ערך סיכום %{name}',
		summary_named_numbered: 'ערך סיכום %{name} ‏(%{number})',
		// (Infographic summary) Infographic: value infographic
		infographicSummary_has_mapping: 'אינפוגרפיקה של %{values}',
		infographicSummary_has_mapping_numbered: 'אינפוגרפיקה של %{values} ‏(%{number})',
		infographicSummary_no_mapping: 'אינפוגרפיקה ריקה',
		infographicSummary_no_mapping_numbered: 'אינפוגרפיקה ריקה (%{number})',
		infographicSummary_named: 'אינפוגרפיקה %{name}',
		infographicSummary_named_numbered: 'אינפוגרפיקה %{name} ‏(%{number})',
		noExtraText_youtube: 'סרטון של YouTube',
		noExtraText_youtube_numbered: 'סרטון YouTube ‏(%{number})',
		// %{text} is the user-provided title of the video
		one_youtube: 'סרטון YouTube %{text}',
		one_youtube_numbered: 'סרטון YouTube %{text} ‏{(%{number})',
		few_youtube: 'קבוצה של %{count} סרטוני YouTube',
		many_youtube: 'קבוצה של %{count} סרטוני YouTube',
		noExtraText_embedMedia: 'קישור מדיה',
		noExtraText_embedMedia_numbered: 'קישור מדיה (%{number})',
		// %{text} is the user-provided title of the media link
		one_embedMedia: 'קישור מדיה %{text}',
		one_embedMedia_numbered: 'קישור מדיה %{text} ‏(%{number})',
		few_embedMedia: 'קבוצה של %{count} קישורי מדיה',
		many_embedMedia: 'קבוצה של %{count} קישורי מדיה',
		noExtraText_media: 'מדיה',
		noExtraText_media_numbered: 'מדיה (%{number})',
		// %{text} is the user-provided title of the media link
		one_media: 'מדיה %{text}',
		one_media_numbered: 'מדיה %{text} ‏(%{number})',
		few_media: 'קבוצה של %{count} פריטיי מדיה',
		many_media: 'קבוצה של %{count} פריטיי מדיה',
		noExtraText_webpage: 'דף רשת',
		noExtraText_webpage_numbered: 'דף רשת (%{number})',
		// %{text} is the user-provided title of the web page
		one_webpage: 'דף רשת %{text}',
		one_webpage_numbered: 'דף רשת %{text} ‏(%{number})',
		few_webpage: 'קבוצה של %{count} דפי רשת',
		many_webpage: 'קבוצה של %{count} דפי רשת',
		one_unknown: 'אובייקט',
		one_unknown_numbered: 'אובייקט (%{number})',
		few_unknown: 'קבוצה של %{count} אובייקטים',
		many_unknown: 'קבוצה של %{count} אובייקטים',

		//a11y label for the left/right arrow for navigation path

		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		next: 'הבא',
		previous: 'הקודם',
		//a11y description

		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		current_nav_group: 'קבוצת הניווט הנוכחית היא %{navigation_group_name}',

		//Page Context
		'filterBlank': '(ריק)',

		// no longer used in this component, moved to dashboard-livewidget.
		// please don't remove from here, or will break R8
		'errMsgFilterItemGenericTitle': 'לא ניתן לטעון את ערכי המסנן',
		'editTimelineHighlight': 'עריכת הבלטה',

		filterDockChevronLeft: 'גלילה בנתונים',
		filterDockChevronRight: 'גלילה בנתונים',
		expand: 'הרחבה',
		collapse: 'כיווץ'

});

// UFRID:7B0AF3BE-7D03-49C9-B2A7-8D1C187141FD

